import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface PenaltiesSectionProps {
  value: any;
  onChange: (value: any) => void;
}

export const PenaltiesSection: React.FC<PenaltiesSectionProps> = ({ value, onChange }) => {
  const [expanded, setExpanded] = useState(false);

  const increment = (field: string) => {
    onChange({ ...value, [field]: (value[field] || 0) + 1 });
  };

  const decrement = (field: string) => {
    onChange({ ...value, [field]: Math.max(0, (value[field] || 0) - 1) });
  };

  return (
    <motion.div className="glass p-6 mb-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h2 className="subsection-title mb-0">Penalties</h2>
        <ChevronDown className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <>
          <div className="mb-4">
            <label className="form-label">Fouls</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('fouls')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.fouls}</span>
              <motion.button
                type="button"
                onClick={() => increment('fouls')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Tech Fouls</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('tech_fouls')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.tech_fouls}</span>
              <motion.button
                type="button"
                onClick={() => increment('tech_fouls')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Yellow Card</label>
            <button
              type="button"
              onClick={() => onChange({ ...value, yellow_card: !value.yellow_card })}
              className={`w-full py-2 rounded-lg font-medium transition-all ${
                value.yellow_card ? 'bg-yellow-600/30 border border-yellow-500/50 text-yellow-300' :
                'bg-gray-700/30 border border-gray-600/50 text-gray-400'
              }`}
            >
              {value.yellow_card ? '⚠ Yellow' : 'None'}
            </button>
          </div>

          <div>
            <label className="form-label">Red Card</label>
            <button
              type="button"
              onClick={() => onChange({ ...value, red_card: !value.red_card })}
              className={`w-full py-2 rounded-lg font-medium transition-all ${
                value.red_card ? 'bg-red-600/30 border border-red-500/50 text-red-300' :
                'bg-gray-700/30 border border-gray-600/50 text-gray-400'
              }`}
            >
              {value.red_card ? '🚫 Disqualified' : 'None'}
            </button>
          </div>
        </>
      )}
    </motion.div>
  );
};
